import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "476",
  "slug": "is-geoguessr-free",
  "title": "Is GeoGuessr Free? Free Play and Paid Access",
  "excerpt": "GeoGuessr offers a free-play route as well as paid subscriptions. Check the game mode and platform before deciding what access you need.",
  "date": "2026-06-18",
  "category": "Community",
  "image": "https://images.unsplash.com/photo-1521295121783-8a321d551ad2?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHx3b3JsZCUyMG1hcCUyMGdsb2JlfGVufDF8MHx8fDE3ODE3NzA0MjV8MA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "2 min",
  "author": "EarthGuessr Team",
  "tldr": "GeoGuessr offers free play and paid Pro subscriptions. Use its official free-play page to check current access, and compare the plan for the mode and platform you intend to use.",
  "content": [
    {
      "type": "paragraph",
      "text": "GeoGuessr has a free-play entry point on its own website. It also sells Pro subscriptions. The useful question is which mode you want to play and which platform you plan to use, rather than whether the entire product is free or paid."
    },
    {
      "type": "heading",
      "text": "Start with the free route"
    },
    {
      "type": "paragraph",
      "text": "Use the official free-play link below to see the current experience. Free access should not be described as unlimited access to every mode, but the existence of subscriptions also does not make the whole game inaccessible without payment."
    },
    {
      "type": "paragraph",
      "text": "If a friend sends you a challenge or invitation, check that specific joining flow. Do not assume that the host's access and each participant's access are identical."
    },
    {
      "type": "heading",
      "text": "Paid subscriptions"
    },
    {
      "type": "paragraph",
      "text": "GeoGuessr's published 2026 price notice lists Pro Unlimited at US$47.88 per year, expressed as $3.99 per month, or US$6.99 when billed monthly. These are the US-dollar figures in that notice, checked on 14 September 2026. The price and terms shown at checkout apply to your currency and purchase."
    },
    {
      "type": "paragraph",
      "text": "The yearly equivalent is not a monthly payment option. Compare the total charge with how long you expect to play before choosing a billing interval."
    },
    {
      "type": "heading",
      "text": "Other ways to play geography games"
    },
    {
      "type": "paragraph",
      "text": "If you want overhead imagery, EarthGuessr offers satellite-location rounds in a browser. Its multiplayer flow requires sign-in. If you want to practise named places on maps, Seterra offers free website quizzes with ads; its paid features are separate."
    },
    {
      "type": "paragraph",
      "text": "These are different tasks. Try the actual format you want before using a subscription price as the deciding factor."
    }
  ],
  "sources": [
    {
      "title": "GeoGuessr: free-play entry point",
      "url": "https://www.geoguessr.com/free"
    },
    {
      "title": "GeoGuessr: 2026 subscription price changes",
      "url": "https://geoguessr.freshdesk.com/support/solutions/articles/206000067275-price-changes-2026"
    },
    {
      "title": "GeoGuessr support: free access to Seterra",
      "url": "https://www.geoguessr.support/support/solutions/articles/206000056685-is-the-seterra-geography-website-free-to-use-"
    }
  ],
  "relatedSlugs": [
    "is-geoguessr-pro-worth-it-2026",
    "geoguessr-alternatives-free"
  ]
};
